import { createParagraph } from '@lumapps/wrex-typography/utils/createParagraph';

import { LIST_ITEM } from '../constants';
import { ListItemElement } from '../types';

/** Create a list item element */
export const createListItem = (children: ListItemElement['children'] = [createParagraph()]): ListItemElement => {
    return { type: LIST_ITEM, children };
};
